import { PUNCH_SUBMITTING, PUNCH_SUBMIT, PUNCH_RESET } from '../actions/index';

let initialState = {
  "loading" : false,
  "status" : null,
  "submitted" : null,
  "message" : null
};

export default function(state = initialState, action) {
  switch(action.type) {
    case PUNCH_SUBMITTING:
      return {
        loading: true,
        message: "Submitting ..."
      }
    case PUNCH_SUBMIT:
      return {
        status: action.payload.status,
        submitted: action.payload.submitted,
        message: action.payload.message
      }
    case PUNCH_RESET:
      return {
        loading: false,
        status: null,
        submitted: null,
        message: null
      }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/reducer_punch.js